import { makeQueryHook } from "utils/apolloUtils";

import { GET_ME } from "./queries";
import { GetMe } from "./__generated__/queries";

export const useMeQuery = makeQueryHook<GetMe>(GET_ME);
